import { FormGroup } from '@ax/ui';
import styles from './NotePreferences.module.scss';
import infoIcon from '@image/info-icon.svg';
import { useState } from 'react';
import InfoModal from '@/components/InfoModal/index.tsx';

interface InputTypeTextProps {
  value: string;
  label: string;
  onValueChanged: (value: string) => void;
  maxLength?: number;
  hint?: { title: string; content: { title: string; value: string }[] };
  analyticsProperties?: { preferenceType: string; noteSection: string };
}

const InputTypeText = ({
  value,
  label,
  onValueChanged,
  maxLength,
  hint,
  analyticsProperties,
}: InputTypeTextProps) => {
  const [isPreferencesModalOpen, setIsPreferencesModalOpen] = useState(false);
  return (
    <>
      <InfoModal
        modalOpen={isPreferencesModalOpen}
        modalClose={() => setIsPreferencesModalOpen(false)}
        content={hint}
        analyticsProperties={analyticsProperties}
      />
      <div className={styles.select__container}>
        <FormGroup className={styles.note__preferences__text__input}>
          <div className={styles.select__label}>
            <label className={styles.preference__select__label__info}>{label}</label>
            {hint && (
              <img
                className={styles.info__icon}
                onClick={() => setIsPreferencesModalOpen(true)}
                src={infoIcon}
                alt="info"
              />
            )}
          </div>
          <textarea
            className={styles.text__area__input}
            rows={2}
            maxLength={maxLength}
            onChange={(e) => onValueChanged(e.target.value)}
            value={value}
            placeholder={'Type here...'}
          ></textarea>
        </FormGroup>
      </div>
    </>
  );
};

export default InputTypeText;
